<template>
    <sa-page-layout ref="SaplPostiLettoPianiView" :btnRouterBackVisible="true" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource">
        <template slot="table-filter">
            <ras-configurazione-posti-letto-piani-view-component ref="cmpRasConfigurazionePostiLettoPianiView" :showModalLoading="showModalLoading" @errorRestCall="onError" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></ras-configurazione-posti-letto-piani-view-component>
        </template>

        <template slot="table-body">
            <ras-configurazione-posti-letto-stanze-list-component ref="cmpRsaConfigurazionePostiLettoStanzeListComponent" :id-piano="idPiano" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RasConfigurazionePostiLettoPianiViewComponent from "../components/RasConfigurazionePostiLettoPianiViewComponent.vue";
import RasConfigurazionePostiLettoStanzeListComponent from "../components/RasConfigurazionePostiLettoStanzeListComponent.vue";
export default {
    components: { SaPageLayout, RasConfigurazionePostiLettoPianiViewComponent, RasConfigurazionePostiLettoStanzeListComponent },
    beforeMount() {
        let me = this;
        me.idPiano = me.$route.params.id;
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsapostilettopiani",
            idPiano: null,
            jsonData: {},
        };
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpRsaConfigurazionePostiLettoStanzeListComponent.loadData();
        },

        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onError(errorData) {
            let me = this;
            me.$refs.SaplPostiLettoPianiView.showModalError(errorData);
        },
    },
};
</script>

<style></style>
